import { useMemo } from "react";

import { useActiveBrandsQuery } from "components/BrandGroupSelect/hooks/useActiveBrandsQuery";
import { toGroupedBrands } from "components/BrandGroupSelect/utils";
import { useBrandGroupsQuery } from "modules/BrandsDashboard/hooks";

export const useGroupedBrands = () => {
  const { data: brands = [] } = useActiveBrandsQuery();
  const { data: brandGroups = [] } = useBrandGroupsQuery();

  return useMemo(() => toGroupedBrands(brands, brandGroups), [brands, brandGroups]);
};
